import { useEffect, useRef } from 'react';
import Echo from 'laravel-echo';
import { createEcho } from './useChatEcho';

export interface PaymentStatusUpdatedPayload {
    gateway_txid: string;
    type: string;
    status: string;
}

interface UsePaymentEchoOptions {
    userId: number | undefined;
    token: string | undefined | null;
    onStatusUpdated: (payload: PaymentStatusUpdatedPayload) => void;
}

/** Listens for the backend notification sent after the PIX webhook settles a charge. */
export function usePaymentEcho({ userId, token, onStatusUpdated }: UsePaymentEchoOptions) {
    const echoRef = useRef<Echo<'reverb'> | null>(null);
    const callbackRef = useRef(onStatusUpdated);
    callbackRef.current = onStatusUpdated;

    useEffect(() => {
        if (!userId || !token) return;

        const echo = createEcho(token);
        echoRef.current = echo;
        echo.private(`payment-user.${userId}`).listen('.PaymentStatusUpdated', (payload: PaymentStatusUpdatedPayload) => {
            callbackRef.current(payload);
        });

        return () => {
            echo.leave(`payment-user.${userId}`);
            echo.disconnect();
            echoRef.current = null;
        };
    }, [userId, token]);
}
